import fetch from 'isomorphic-fetch';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import Toggle from 'react-toggle';
import {bindActionCreators} from 'redux';
import {openPreviewModule, toggleEnabled, switchModuleMode} from './reducer';
import {Trans} from 'react-i18next';
import PreviewHint from '../../../pages/products/addoreditproduct/components/PreviewHint';
import utils from '../../../utils/webmoduleUtils';
import i18n from '../../../utils/i18n';
import './index.css';
import _isEmpty from 'lodash/isEmpty';
@connect(
  state => ({
    isOpen: state.components.webmodule.previewmodule.isOpen,
    isEnabled: state.components.webmodule.previewmodule.isEnabled,
    mode: state.components.webmodule.previewmodule.mode,
    modelImage: state.components.webmodule.previewmodule.modelImage,
    handleTwoModule: state.components.webmodule.previewmodule.handleTwoModule,
    functionType: state.components.auth.accountSummary.customer.functionType,
  }),
  dispatch =>
    bindActionCreators(
      {openPreviewModule, toggleEnabled, switchModuleMode},
      dispatch
    )
)
export default class PreviewModule extends Component {
  // componentDidMount() {
  //   this.unmountYMK();
  //   this.loadWebModule().then(() => this.doInitYMK());
  // }

  componentWillUnmount() {
    this.unmountYMK();
  }

  getWidth = width => {
    const {functionType} = this.props;
    if (functionType === 'EYEWEAR') {
      return width <= 1024 ? 360 : null;
    } else {
      return width <= 1024 && width >= 768
        ? width * 0.36
        : width < 768
        ? 300
        : null;
    }
  };

  getHeight = width => {
    const {functionType} = this.props;
    if (functionType === 'EYEWEAR') {
      return width <= 1024 ? 480 : null;
    } else {
      return width <= 1024 && width >= 768
        ? width * 0.5
        : width < 768
        ? 400
        : null;
    }
  };

  initYmk = (type, data) => {
    const {isEdit} = this.props;
    if (isEdit && _isEmpty(data)) {
      return;
    }
    const {mode, modelImage, handleTwoModule} = this.props;
    const width = window.innerWidth;
    if (!handleTwoModule) {
      if (window.YMK) {
        if (type && type === 'productlist') {
          i18n.language === 'ja'
            ? window.YMK.init({
                language: 'jpn',
                width: this.getWidth(width),
                height: this.getHeight(width),
              })
            : window.YMK.init({
                width: this.getWidth(width),
                height: this.getHeight(width),
              });
        } else {
          this.listenerId = window.YMK.addEventListener('loaded', () => {
            this.module.style.visibility = 'visible';
          });
          window.YMK.init({
            disable2ColorComparison: true,
            disableLiveMode: mode === 'photo',
          });
        }
      }

      if (mode === 'live') {
        if (type && data) {
          window.YMK && window.YMK.setPreview({type: type}, data);
        } else {
          window.YMK && window.YMK.open(true);
        }
      } else {
        fetch(modelImage + '?' + new Date().getTime())
          .then(r => r.blob())
          .then(rr => {
            if (type && data) {
              window.YMK && window.YMK.setPreview({type: type}, data);
            } else {
              window.YMK && window.YMK.open(false, rr);
            }
          });
      }
    }
  };

  doInitYMK(type, data) {
    if (!window.YMK) {
      window.ymkAsyncInit = () => this.initYmk(type, data);
    } else {
      this.initYmk(type, data);
    }
  }

  unmountYMK() {
    if (this.props.isEnabled && window.YMK) {
      window.YMK.close();
      window.YMK.removeEventListener(this.listenerId);
    }
  }

  loadWebModule = async () => {
    await utils.loadWebModule();
  };

  render() {
    const {
      isEnabled,
      toggleEnabled,
      mode,
      switchModuleMode,
      type,
      data,
    } = this.props;
    return (
      <div className="m-portlet" style={{position: 'sticky', top: '70px'}}>
        <div className="m-portlet__head">
          <div className="m-portlet__head-caption">
            <h5 className="m-portlet__head-text">
              {type === 'productlist' ? (
                <PreviewHint />
              ) : (
                <Trans i18nKey="tutorials.steps.addskulooktour.preview.title">
                  Preview
                </Trans>
              )}
            </h5>
          </div>
          <div className="m-portlet__head-tools">
            <div style={{maxWidth: '360px'}}>
              <div className="float-left">
                <Toggle
                  checked={isEnabled}
                  onChange={e => toggleEnabled(e.target.checked)}
                  icons={{unchecked: false}}
                />
              </div>
              <div className="float-right kt-margin-b-10">
                {isEnabled && type !== 'productlist' && (
                  <div className="btn-group">
                    <button
                      type="button"
                      className={`btn btn-sm ${
                        mode === 'photo' ? 'btn-primary' : 'btn-default'
                      }`}
                      onClick={() => {
                        switchModuleMode('photo');
                        this.unmountYMK();
                      }}
                    >
                      <Trans i18nKey="c.r.querymode.photo">Photo</Trans>
                    </button>
                    <button
                      type="button"
                      className={`btn btn-sm ${
                        mode === 'live' ? 'btn-primary' : 'btn-default'
                      }`}
                      onClick={() => {
                        switchModuleMode('live');
                        this.unmountYMK();
                      }}
                    >
                      <Trans i18nKey="c.r.querymode.live">Live</Trans>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="m-portlet__body">
          <div
            className="tutorial-add-sku-look-preview"
            style={{
              marginLeft: '340px',
              width: '1px',
            }}
          />
          {isEnabled && (
            <div
              id="YMK-module"
              ref={r => {
                this.module = r;
                if (r != null) {
                  this.loadWebModule().then(() => this.doInitYMK(type, data));
                }
              }}
            />
          )}
        </div>
      </div>
    );
  }
}
